import PropTypes from 'prop-types';
import { Text } from '@brandwatch/axiom-components';
import './DeckTime.css';

import { createElement as el, lazy, Suspense } from 'react';
import { useTime } from '../hooks';
import {defaultOptions} from '../lib/locale';

const FormattedDate = lazy(() => import(/* webpackChunkName: 'formatted-date' */ './FormattedDate.jsx'));

const DeckTime = ({ timeZone: timezone }) => {
  const time = useTime(1000);

  const formattedDate = el(
    Suspense,
    {fallback: el('div')},
    el(FormattedDate, {time, timezone, format: 'D MMMM h:mm zz'})
  );

  return el(
    Text,
    {
      className: 'DeckTime',
      space: 'x0',
      textCase: 'upper',
      textColor: 'subtle',
      textSize: 'label'
    },
    formattedDate
  );
};

DeckTime.defaultProps = {
  timeZone: defaultOptions().timezone
};

DeckTime.propTypes = {
  timeZone: PropTypes.string
};

export default DeckTime;
